// @ts-ignore
const svgsContext = require.context('../../../styling/custom-theme/images/symbols/', false, /\.svg$/)
const svgs = svgsContext.keys().map(svgsContext)

module.exports = svgs
